import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { IndexType } from "@/types/IndexType";
import { PageType } from "@/types/pageTypes";

export type UserInfoType = {
  user: {
    userId?: number;
    name?: string;
    email?: string;
  };
  company: {
    companyId?: number;
    name?: string;
    address?: string;
  };
};

// Define a type for the slice state
export interface ApplicationMainSliceState {
  currentPage: PageType;
  selectedIndex?: IndexType;
  authenticated?: boolean;
  isUserFeatureNotAvailableDialogOpen: boolean;
  userInfo?: UserInfoType;
}

// Define the initial state using that type
const initialState: ApplicationMainSliceState = {
  currentPage: PageType.LandingPage,
  selectedIndex: undefined,
  authenticated: false,
  isUserFeatureNotAvailableDialogOpen: false,
  userInfo: undefined,
};

// Implement the slice
export const applicationMainSlice = createSlice({
  name: "applicationMain",
  // 'createSlice' will infer the state type from the 'initialState' argument
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<PageType>) => {
      state.currentPage = action.payload;
    },
    setSelectedIndex: (state, action: PayloadAction<IndexType>) => {
      state.selectedIndex = action.payload;
    },
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.authenticated = action.payload;
    },
    setUserFeatureNotAvailableDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isUserFeatureNotAvailableDialogOpen = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<UserInfoType | undefined>) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setCurrentPage, setSelectedIndex, setAuthenticated, setUserFeatureNotAvailableDialogOpen, setUserInfo } =
  applicationMainSlice.actions;

export const PagesReducer = applicationMainSlice.reducer;
